import axios from 'axios';
import { API_CONFIG, resolveApiBaseUrl } from '../config/api';

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: API_CONFIG.timeout,
  headers: API_CONFIG.headers,
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Token adicionado à requisição:', config.url);
    } else {
      console.log('⚠️  Nenhum token encontrado para:', config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas
api.interceptors.response.use(
  (response) => {
    console.log('✅ Resposta recebida:', response.config.url, response.status);
    return response;
  },
  (error) => {
    console.log('❌ Erro na requisição:', error.config?.url, error.response?.status);
    
    // Se receber 401, limpar token e redirecionar para login
    // Apenas se não for uma rota de autenticação
    if (error.response?.status === 401 && !error.config.url.includes('/auth/')) {
      console.log('🚪 Redirecionando para login devido a 401');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;
